import { LastBidderItemController } from "./last-bidder-item.controller";
import "./item-bids-dialog/item-bids-trigger.component";

angular
    .module("thor.online-containers.edit.last-bidder-item.component", [
        "thor.online-containers.edit.item-bids-trigger.component"
    ])
    .component("lastBidderItem", {
        bindings: {
            item: "<",
            paymentStatus: "<",
            saleCurrency: "<",
            selectedLang: "<"
        },
        controller: LastBidderItemController,
        template: require("./last-bidder-item.html")
    });
